import * as React from 'react'

const getHashParam = (hash: string, keyName: string) =>
  new URLSearchParams(hash.replace('#', '?')).get(keyName) ?? undefined

export const useHashParam = (keyName: string) => {
  const [value, setValue] = React.useState<string | undefined>(
    getHashParam(document.location.hash, keyName),
  )
  React.useEffect(() => {
    const locationHashChanged = (event: HashChangeEvent) => {
      const newValue = getHashParam('#' + event.newURL.split('#')[1], keyName)
      setValue(newValue)
    }

    window.addEventListener('hashchange', locationHashChanged)
    return () => {
      window.removeEventListener('hashchange', locationHashChanged)
    }
  }, [keyName])

  return value
}

export const setHashParam = (keyName: string, newValue: string | undefined) => {
  const searchParams = new URLSearchParams('?' + document.location.hash.replace('#', ''))
  if (newValue) {
    searchParams.set(keyName, newValue)
  } else {
    searchParams.delete(keyName)
  }
  document.location.hash = searchParams.toString()
}
